<div class="drag-container">
  <h2>{{ title }}</h2>
  <p>{{ subTitle }}</p>
  <label *ngIf="label">{{ label }}
    <span
      *ngIf="label && (required || getErrorMessage() === requiredMessage)"
      class="text-danger"
    >*</span>
  </label>
  <div
    class="upload-container d-flex justify-content-center align-items-center"
  >
    <i class="icon-file-upload"></i>
    <h1>Drag & drop</h1>
    <p class="text-muted">
      your file here, or <a (click)="file.click()">browse</a>
      <input
        #file
        type="file"
        hidden
        (change)="loadFiles($event)"
        multiple
        [accept]="mime"
      />
    </p>
    <p class="text-muted">
      upload max {{ maxFiles }} {{ maxFiles > 1 ? "files" : "file" }}
    </p>
  </div>
  <div
    [ngClass]="{
      valid: file['size'] <= allowedFileSize * 1e6,
      invalid: file['size'] > allowedFileSize * 1e6
    }"
    class="alert"
    *ngFor="let file of files; let i = index"
  >
    <button mat-button type="button" class="close" (click)="removeFile(i)">
      <i class="icon-close"></i>
    </button>
    <span>{{ getFileName(file) }}</span>
  </div>
</div>
